import { render, staticRenderFns } from "./ClassManageResources.vue?vue&type=template&id=01d1dc96&scoped=true"
import script from "./ClassManageResources.vue?vue&type=script&lang=js"
export * from "./ClassManageResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1dc96",
  null
  
)

export default component.exports